/** @format */

import React from 'react'
import styled from 'styled-components'

interface DividerProps {
  className?: string
}

const Divider: React.FC<DividerProps> = ({ className }) => {
  return <div className={className}></div>
}

export default styled(Divider)`
  position: relative;
  top: 0;
  display: inline-block;
  height: 12px;
  vertical-align: middle;
  border-top: 0;
  border-left: 1px solid #ccc;
`
